/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfMedia } from '../models';
// @ts-ignore
import type { BfMediaModerationInput } from '../models';
// @ts-ignore
import type { BfMediaReport } from '../models';
// @ts-ignore
import type { BfMediaReportInput } from '../models';
// @ts-ignore
import type { BfMediaSourceEntry } from '../models';
// @ts-ignore
import type { BfMediaType } from '../models';
// @ts-ignore
import type { BfMediaUrl } from '../models';
// @ts-ignore
import type { BfMediaUserContent } from '../models';
// @ts-ignore
import type { BfMediaVoteInput } from '../models';
// @ts-ignore
import type { BfPublishingStatus } from '../models';
// @ts-ignore
import type { BfSourceProcess } from '../models';
// @ts-ignore
import type { BulkDeleteOutcome } from '../models';
// @ts-ignore
import type { BulkDeleteRequest } from '../models';
/**
 * MediaApi - axios parameter creator
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data.
         * @summary Add media
         * @param {BfMediaType} mediaType Type of media to upload
         * @param {BfMediaUserContent} bfMediaUserContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMedia: async (mediaType: BfMediaType, bfMediaUserContent: BfMediaUserContent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaType' is not null or undefined
            assertParamExists('addMedia', 'mediaType', mediaType)
            // verify required parameter 'bfMediaUserContent' is not null or undefined
            assertParamExists('addMedia', 'bfMediaUserContent', bfMediaUserContent)
            const localVarPath = `/v1/media/external/{media_type}`
                .replace(`{${"media_type"}}`, encodeURIComponent(String(mediaType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfMediaUserContent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the supplied media IDs after asserting every record belongs to `source`. Best-effort across the batch; per-id outcome returned.
         * @summary Bulk-delete media for a source
         * @param {BulkDeleteRequest} bulkDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteMedia: async (bulkDeleteRequest: BulkDeleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkDeleteRequest' is not null or undefined
            assertParamExists('bulkDeleteMedia', 'bulkDeleteRequest', bulkDeleteRequest)
            const localVarPath = `/v1/media/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete media by ID
         * @param {string} mediaId ID of the media to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedia: async (mediaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('deleteMedia', 'mediaId', mediaId)
            const localVarPath = `/v1/media/{media_id}`
                .replace(`{${"media_id"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the media object if it exists and the user has access to it.
         * @summary Get media by ID
         * @param {string} mediaId ID of the media to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaById: async (mediaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('getMediaById', 'mediaId', mediaId)
            const localVarPath = `/v1/media/{media_id}`
                .replace(`{${"media_id"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all media objects for the specified organisation if the user has access to it.
         * @summary Get media for Org
         * @param {string} orgId ID of the organisation to fetch media for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaForOrg: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getMediaForOrg', 'orgId', orgId)
            const localVarPath = `/v1/media/org/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated lean projection of records owned by a given source. Intended for external writers to reconcile their slice: diff returned `mediaId`s against locally-known ones, then bulk-delete orphans via `POST /v1/media/bulk-delete`.
         * @summary List media for a source
         * @param {BfSourceProcess} source Source process to list records for
         * @param {string | null} [after] Cursor — pass the previous page\&#39;s last &#x60;createdAt&#x60; to page forward.
         * @param {number | null} [limit] Page size, clamped server-side to [1, 5000]. Defaults to 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMediaBySource: async (source: BfSourceProcess, after?: string | null, limit?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('listMediaBySource', 'source', source)
            const localVarPath = `/v1/media/source/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (after !== undefined) {
                localVarQueryParameter['after'] = (after as any instanceof Date) ?
                    (after as any).toISOString() :
                    after;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The moderator\'s identity is taken from the auth token and the target media id from the URL path — neither is accepted from the request body.
         * @summary Moderate media
         * @param {string} mediaId ID of the media to moderate
         * @param {BfMediaModerationInput} bfMediaModerationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderateMedia: async (mediaId: string, bfMediaModerationInput: BfMediaModerationInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('moderateMedia', 'mediaId', mediaId)
            // verify required parameter 'bfMediaModerationInput' is not null or undefined
            assertParamExists('moderateMedia', 'bfMediaModerationInput', bfMediaModerationInput)
            const localVarPath = `/v1/media/moderation/{media_id}`
                .replace(`{${"media_id"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfMediaModerationInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Moderate media count
         * @param {BfPublishingStatus} status Publishing status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderationCount: async (status: BfPublishingStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('moderationCount', 'status', status)
            const localVarPath = `/v1/media/moderation/counts/{status}`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Moderation queue
         * @param {BfPublishingStatus} status Publishing status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderationQueue: async (status: BfPublishingStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('moderationQueue', 'status', status)
            const localVarPath = `/v1/media/moderation/{status}`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The caller\'s identity is taken from the auth token — `user_id` is not accepted from the request body.
         * @summary Report media
         * @param {BfMediaReportInput} bfMediaReportInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMedia: async (bfMediaReportInput: BfMediaReportInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfMediaReportInput' is not null or undefined
            assertParamExists('reportMedia', 'bfMediaReportInput', bfMediaReportInput)
            const localVarPath = `/v1/media/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfMediaReportInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reports
         * @param {string} mediaId ID of the media to fetch reports for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reports: async (mediaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('reports', 'mediaId', mediaId)
            const localVarPath = `/v1/media/reports/{media_id}`
                .replace(`{${"media_id"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the binary content of the media
         * @summary Retrieve media by ID
         * @param {string} mediaId ID of the media to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMedia: async (mediaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaId' is not null or undefined
            assertParamExists('retrieveMedia', 'mediaId', mediaId)
            const localVarPath = `/v1/media/retrieve/{media_id}`
                .replace(`{${"media_id"}}`, encodeURIComponent(String(mediaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/octet-stream';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data. Any user with read access to the target organisation may upload media attributed to it.
         * @summary Upload media
         * @param {BfMediaType} mediaType Type of media to upload
         * @param {File} file File to upload
         * @param {string | null} [orgId] Organisation ID, the icon will be associated with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMedia: async (mediaType: BfMediaType, file: File, orgId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaType' is not null or undefined
            assertParamExists('uploadMedia', 'mediaType', mediaType)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadMedia', 'file', file)
            const localVarPath = `/v1/media/upload/{media_type}`
                .replace(`{${"media_type"}}`, encodeURIComponent(String(mediaType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }

            if (orgId !== undefined) { 
                localVarFormParams.append('org_id', orgId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vote media
         * @param {BfMediaVoteInput} bfMediaVoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteMedia: async (bfMediaVoteInput: BfMediaVoteInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfMediaVoteInput' is not null or undefined
            assertParamExists('voteMedia', 'bfMediaVoteInput', bfMediaVoteInput)
            const localVarPath = `/v1/media/vote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfMediaVoteInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data.
         * @summary Add media
         * @param {BfMediaType} mediaType Type of media to upload
         * @param {BfMediaUserContent} bfMediaUserContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMedia(mediaType: BfMediaType, bfMediaUserContent: BfMediaUserContent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMedia(mediaType, bfMediaUserContent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.addMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the supplied media IDs after asserting every record belongs to `source`. Best-effort across the batch; per-id outcome returned.
         * @summary Bulk-delete media for a source
         * @param {BulkDeleteRequest} bulkDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteMedia(bulkDeleteRequest: BulkDeleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkDeleteOutcome>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteMedia(bulkDeleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.bulkDeleteMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete media by ID
         * @param {string} mediaId ID of the media to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMedia(mediaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMedia(mediaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.deleteMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the media object if it exists and the user has access to it.
         * @summary Get media by ID
         * @param {string} mediaId ID of the media to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaById(mediaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfMediaUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaById(mediaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.getMediaById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all media objects for the specified organisation if the user has access to it.
         * @summary Get media for Org
         * @param {string} orgId ID of the organisation to fetch media for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaForOrg(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfMediaUrl>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaForOrg(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.getMediaForOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated lean projection of records owned by a given source. Intended for external writers to reconcile their slice: diff returned `mediaId`s against locally-known ones, then bulk-delete orphans via `POST /v1/media/bulk-delete`.
         * @summary List media for a source
         * @param {BfSourceProcess} source Source process to list records for
         * @param {string | null} [after] Cursor — pass the previous page\&#39;s last &#x60;createdAt&#x60; to page forward.
         * @param {number | null} [limit] Page size, clamped server-side to [1, 5000]. Defaults to 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMediaBySource(source: BfSourceProcess, after?: string | null, limit?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfMediaSourceEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMediaBySource(source, after, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.listMediaBySource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The moderator\'s identity is taken from the auth token and the target media id from the URL path — neither is accepted from the request body.
         * @summary Moderate media
         * @param {string} mediaId ID of the media to moderate
         * @param {BfMediaModerationInput} bfMediaModerationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moderateMedia(mediaId: string, bfMediaModerationInput: BfMediaModerationInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moderateMedia(mediaId, bfMediaModerationInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.moderateMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Moderate media count
         * @param {BfPublishingStatus} status Publishing status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moderationCount(status: BfPublishingStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moderationCount(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.moderationCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Moderation queue
         * @param {BfPublishingStatus} status Publishing status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moderationQueue(status: BfPublishingStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfMediaUrl>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moderationQueue(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.moderationQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The caller\'s identity is taken from the auth token — `user_id` is not accepted from the request body.
         * @summary Report media
         * @param {BfMediaReportInput} bfMediaReportInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportMedia(bfMediaReportInput: BfMediaReportInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportMedia(bfMediaReportInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.reportMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reports
         * @param {string} mediaId ID of the media to fetch reports for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reports(mediaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfMediaReport>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reports(mediaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.reports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the binary content of the media
         * @summary Retrieve media by ID
         * @param {string} mediaId ID of the media to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveMedia(mediaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveMedia(mediaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.retrieveMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data. Any user with read access to the target organisation may upload media attributed to it.
         * @summary Upload media
         * @param {BfMediaType} mediaType Type of media to upload
         * @param {File} file File to upload
         * @param {string | null} [orgId] Organisation ID, the icon will be associated with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMedia(mediaType: BfMediaType, file: File, orgId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMedia(mediaType, file, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.uploadMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vote media
         * @param {BfMediaVoteInput} bfMediaVoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteMedia(bfMediaVoteInput: BfMediaVoteInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfMediaUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteMedia(bfMediaVoteInput, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.voteMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MediaApi - factory interface
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data.
         * @summary Add media
         * @param {BfMediaType} mediaType Type of media to upload
         * @param {BfMediaUserContent} bfMediaUserContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMedia(mediaType: BfMediaType, bfMediaUserContent: BfMediaUserContent, options?: RawAxiosRequestConfig): AxiosPromise<BfMedia> {
            return localVarFp.addMedia(mediaType, bfMediaUserContent, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the supplied media IDs after asserting every record belongs to `source`. Best-effort across the batch; per-id outcome returned.
         * @summary Bulk-delete media for a source
         * @param {BulkDeleteRequest} bulkDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteMedia(bulkDeleteRequest: BulkDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkDeleteOutcome> {
            return localVarFp.bulkDeleteMedia(bulkDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete media by ID
         * @param {string} mediaId ID of the media to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedia(mediaId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMedia(mediaId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the media object if it exists and the user has access to it.
         * @summary Get media by ID
         * @param {string} mediaId ID of the media to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaById(mediaId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfMediaUrl> {
            return localVarFp.getMediaById(mediaId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all media objects for the specified organisation if the user has access to it.
         * @summary Get media for Org
         * @param {string} orgId ID of the organisation to fetch media for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaForOrg(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfMediaUrl>> {
            return localVarFp.getMediaForOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated lean projection of records owned by a given source. Intended for external writers to reconcile their slice: diff returned `mediaId`s against locally-known ones, then bulk-delete orphans via `POST /v1/media/bulk-delete`.
         * @summary List media for a source
         * @param {BfSourceProcess} source Source process to list records for
         * @param {string | null} [after] Cursor — pass the previous page\&#39;s last &#x60;createdAt&#x60; to page forward.
         * @param {number | null} [limit] Page size, clamped server-side to [1, 5000]. Defaults to 500.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMediaBySource(source: BfSourceProcess, after?: string | null, limit?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfMediaSourceEntry>> {
            return localVarFp.listMediaBySource(source, after, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * The moderator\'s identity is taken from the auth token and the target media id from the URL path — neither is accepted from the request body.
         * @summary Moderate media
         * @param {string} mediaId ID of the media to moderate
         * @param {BfMediaModerationInput} bfMediaModerationInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderateMedia(mediaId: string, bfMediaModerationInput: BfMediaModerationInput, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.moderateMedia(mediaId, bfMediaModerationInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Moderate media count
         * @param {BfPublishingStatus} status Publishing status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderationCount(status: BfPublishingStatus, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.moderationCount(status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Moderation queue
         * @param {BfPublishingStatus} status Publishing status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moderationQueue(status: BfPublishingStatus, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfMediaUrl>> {
            return localVarFp.moderationQueue(status, options).then((request) => request(axios, basePath));
        },
        /**
         * The caller\'s identity is taken from the auth token — `user_id` is not accepted from the request body.
         * @summary Report media
         * @param {BfMediaReportInput} bfMediaReportInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMedia(bfMediaReportInput: BfMediaReportInput, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.reportMedia(bfMediaReportInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reports
         * @param {string} mediaId ID of the media to fetch reports for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reports(mediaId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfMediaReport>> {
            return localVarFp.reports(mediaId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the binary content of the media
         * @summary Retrieve media by ID
         * @param {string} mediaId ID of the media to fetch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMedia(mediaId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.retrieveMedia(mediaId, options).then((request) => request(axios, basePath));
        },
        /**
         * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data. Any user with read access to the target organisation may upload media attributed to it.
         * @summary Upload media
         * @param {BfMediaType} mediaType Type of media to upload
         * @param {File} file File to upload
         * @param {string | null} [orgId] Organisation ID, the icon will be associated with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMedia(mediaType: BfMediaType, file: File, orgId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<BfMedia> {
            return localVarFp.uploadMedia(mediaType, file, orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vote media
         * @param {BfMediaVoteInput} bfMediaVoteInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteMedia(bfMediaVoteInput: BfMediaVoteInput, options?: RawAxiosRequestConfig): AxiosPromise<BfMediaUrl> {
            return localVarFp.voteMedia(bfMediaVoteInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaApi - object-oriented interface
 */
export class MediaApi extends BaseAPI {
    /**
     * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data.
     * @summary Add media
     * @param {BfMediaType} mediaType Type of media to upload
     * @param {BfMediaUserContent} bfMediaUserContent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addMedia(mediaType: BfMediaType, bfMediaUserContent: BfMediaUserContent, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).addMedia(mediaType, bfMediaUserContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the supplied media IDs after asserting every record belongs to `source`. Best-effort across the batch; per-id outcome returned.
     * @summary Bulk-delete media for a source
     * @param {BulkDeleteRequest} bulkDeleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkDeleteMedia(bulkDeleteRequest: BulkDeleteRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).bulkDeleteMedia(bulkDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete media by ID
     * @param {string} mediaId ID of the media to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMedia(mediaId: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).deleteMedia(mediaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the media object if it exists and the user has access to it.
     * @summary Get media by ID
     * @param {string} mediaId ID of the media to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMediaById(mediaId: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).getMediaById(mediaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all media objects for the specified organisation if the user has access to it.
     * @summary Get media for Org
     * @param {string} orgId ID of the organisation to fetch media for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMediaForOrg(orgId: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).getMediaForOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated lean projection of records owned by a given source. Intended for external writers to reconcile their slice: diff returned `mediaId`s against locally-known ones, then bulk-delete orphans via `POST /v1/media/bulk-delete`.
     * @summary List media for a source
     * @param {BfSourceProcess} source Source process to list records for
     * @param {string | null} [after] Cursor — pass the previous page\&#39;s last &#x60;createdAt&#x60; to page forward.
     * @param {number | null} [limit] Page size, clamped server-side to [1, 5000]. Defaults to 500.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listMediaBySource(source: BfSourceProcess, after?: string | null, limit?: number | null, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).listMediaBySource(source, after, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The moderator\'s identity is taken from the auth token and the target media id from the URL path — neither is accepted from the request body.
     * @summary Moderate media
     * @param {string} mediaId ID of the media to moderate
     * @param {BfMediaModerationInput} bfMediaModerationInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moderateMedia(mediaId: string, bfMediaModerationInput: BfMediaModerationInput, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).moderateMedia(mediaId, bfMediaModerationInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Moderate media count
     * @param {BfPublishingStatus} status Publishing status to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moderationCount(status: BfPublishingStatus, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).moderationCount(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Moderation queue
     * @param {BfPublishingStatus} status Publishing status to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public moderationQueue(status: BfPublishingStatus, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).moderationQueue(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The caller\'s identity is taken from the auth token — `user_id` is not accepted from the request body.
     * @summary Report media
     * @param {BfMediaReportInput} bfMediaReportInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reportMedia(bfMediaReportInput: BfMediaReportInput, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).reportMedia(bfMediaReportInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reports
     * @param {string} mediaId ID of the media to fetch reports for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reports(mediaId: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).reports(mediaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the binary content of the media
     * @summary Retrieve media by ID
     * @param {string} mediaId ID of the media to fetch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public retrieveMedia(mediaId: string, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).retrieveMedia(mediaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * All uploaded media may be publicly accessible, so ensure you do not upload sensitive data. Any user with read access to the target organisation may upload media attributed to it.
     * @summary Upload media
     * @param {BfMediaType} mediaType Type of media to upload
     * @param {File} file File to upload
     * @param {string | null} [orgId] Organisation ID, the icon will be associated with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadMedia(mediaType: BfMediaType, file: File, orgId?: string | null, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).uploadMedia(mediaType, file, orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vote media
     * @param {BfMediaVoteInput} bfMediaVoteInput 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public voteMedia(bfMediaVoteInput: BfMediaVoteInput, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).voteMedia(bfMediaVoteInput, options).then((request) => request(this.axios, this.basePath));
    }
}

